import { Typography } from 'antd'

import { useStyles } from './styles'

import type { TextProps as AntTextProps } from 'antd/es/typography/Text'
import type { FullToken } from 'antd-style'

const { Text: AntText } = Typography

export type TextProps = {
  size?: number
  weight?: number
  color?: keyof FullToken
} & AntTextProps

export const Text = ({
  size,
  weight,
  color,
  children,
  className,
  ...props
}: TextProps) => {
  const { styles, cx } = useStyles({ size, weight, color })

  return (
    <AntText
      hidden={!children}
      className={cx(styles.text, className)}
      {...props}
    >
      {children}
    </AntText>
  )
}
